import cn from "classnames"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav } from "reactstrap"
import { useSelector } from "swiipe.portal.shared"
import {
    filterAndSortUserRelationsForSwitchUserMenu,
    getIconClassForRelation,
    returnActiveUserRelations,
} from "../../services/userRelationService"
import { partnerSelectors } from "../../store/reducers/partnerReducer"
import { useReduxDispatch } from "../../store/useReduxDispatch"
import { useShowLoggedInMenus } from "./../../services/authService"
import { navigationService } from "./../../services/navigationService"
import { userRelationSelectors } from "./../../store/reducers/userRelationReducer"
import { signOutThunk, switchUserThunk } from "./../../store/thunks/startupThunks"
import { IUserRelationFlattened } from "./../../type/IUserRelation"
import "./SwitchUserMenu.scss"

interface ISwitchUserMenuProps {}

interface IOptionProps {
    iconClass: string
    text: string
    isLogout?: boolean
}
const Option = ({ iconClass, text, isLogout }: IOptionProps) => {
    return (
        <>
            <span className={`icon ${iconClass}`} />
            <span className={cn("account-name", "d-md-inline-block")}>{text}</span>
        </>
    )
}

const SwitchUserMenu = ({}: ISwitchUserMenuProps) => {
    const showLoggedInMenus = useShowLoggedInMenus()

    const dispatch = useReduxDispatch()

    const currentUserRelation = useSelector(userRelationSelectors.currentUserRelation)
    const userRelationsFlattened =
        useSelector(userRelationSelectors.userRelationsFlattened)?.filter((r) => !r.markedDeletion) || []
    const partnerMerchantRelationsAll = useSelector(partnerSelectors.partnerMerchantRelationsAll)
    const lastVisitedAccounts = useSelector(userRelationSelectors.lastUsedRelations)
    const partnersContainMasterPartner = useSelector(partnerSelectors.partnersContainMasterPartner)

    const userRelationsFlattenedActive = returnActiveUserRelations(
        userRelationsFlattened,
        partnerMerchantRelationsAll,
        partnersContainMasterPartner
    )

    const getUserRealtionsToShow = (): IUserRelationFlattened[] => {
        return filterAndSortUserRelationsForSwitchUserMenu(userRelationsFlattenedActive, lastVisitedAccounts)
    }

    const userRelationsToShow = userRelationsFlattenedActive.length > 5 ? getUserRealtionsToShow() : userRelationsFlattenedActive
    const [isOpen, setIsOpen] = useState(false)
    const { t } = useTranslation()

    if (!currentUserRelation || !showLoggedInMenus) {
        return null
    }

    const getOption = (userRelation: IUserRelationFlattened) => {
        return <Option iconClass={getIconClassForRelation(userRelation)} text={userRelation.name || ""} />
    }

    const onUserRelationClick = (userRelation: IUserRelationFlattened) => {
        dispatch(switchUserThunk(userRelation))
    }

    const onLogoutClick = () => {
        dispatch(signOutThunk())
    }

    return (
        <Nav navbar>
            <Dropdown nav className="navbar-dropdown" isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
                <DropdownToggle nav caret>
                    {getOption(currentUserRelation)}
                </DropdownToggle>
                <DropdownMenu>
                    {userRelationsToShow.slice(0, 5).map((userRelation, index) => {
                        const optionComp = getOption(userRelation)
                        if (!optionComp || userRelation.id === currentUserRelation.id) {
                            return null
                        }
                        return (
                            <DropdownItem onClick={() => onUserRelationClick(userRelation)} key={index}>
                                {optionComp}
                            </DropdownItem>
                        )
                    })}
                    {userRelationsFlattenedActive.length > 5 && (
                        <DropdownItem onClick={() => navigationService.navigate("manageuserrelations")}>
                            <Option iconClass="icon-roleswitch-seall" text={t("menu.showAll")} />
                        </DropdownItem>
                    )}
                    <DropdownItem onClick={() => onLogoutClick()}>
                        <Option iconClass="icon-nav-logout" isLogout text={t("menu.logout")} />
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </Nav>
    )
}

export default SwitchUserMenu
